import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { localized } from "@/i18n";
import PlaceCard from "@/components/PlaceCard";
import ShareButton from "@/components/ShareButton";
import { AudioGuide } from "@/components/assistant/AudioGuide";

export default function CollectionDetail() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const { t, lang } = useApp();
  const [col, setCol] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/collections/${slug}`).then((r) => setCol(r.data)).catch(() => setCol(null)).finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="py-20 text-center text-ink-muted">{t("loading")}</div>;
  if (!col) return <div className="py-20 text-center text-ink-muted">{t("place_not_found")}</div>;

  return (
    <div className="space-y-5">
      <div className="relative -mx-4 -mt-4 h-56 overflow-hidden">
        <img src={col.cover_image} alt="" className="h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-black/20" />
        <button data-testid="collection-back" onClick={() => navigate(-1)} className="absolute left-4 top-4 grid h-10 w-10 place-items-center rounded-full bg-white/90 text-ink shadow backdrop-blur">
          <ArrowLeft className="h-5 w-5" />
        </button>
        <ShareButton title={localized(col.title, lang)} url={window.location.href} light testid="collection-share-btn" className="absolute right-4 top-4" />
        <div className="absolute inset-x-0 bottom-0 p-5 text-white">
          <span className="inline-block rounded-full bg-citrus/90 px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide">{localized(col.badge, lang)}</span>
          <h1 className="mt-2 font-heading text-2xl font-extrabold leading-tight">{localized(col.title, lang)}</h1>
          <p className="mt-1 text-sm opacity-90">{localized(col.subtitle, lang)}</p>
        </div>
      </div>

      <p className="text-sm font-semibold text-ink-muted">{col.places?.length} {t("places_in_collection")}</p>
      <AudioGuide key={col.id} collectionId={col.id} />

      <div className="grid grid-cols-2 gap-4">
        {(col.places || []).map((p) => <PlaceCard key={p.id} place={p} />)}
      </div>
    </div>
  );
}
